import React, { FunctionComponent } from 'react';
import { Typography, TTypographyProps } from '@rbx/ui';
import type { SchemaObjectType } from '@modules/openCloud/utils/oasTypes';

export interface OpenCloudTypeReferenceProps {
  type: SchemaObjectType;
  variant?: TTypographyProps['variant'];
}

const OpenCloudTypeReference: FunctionComponent<
  React.PropsWithChildren<OpenCloudTypeReferenceProps>
> = ({ type, variant = 'code' }) => {
  return (
    <Typography variant={variant} color='secondary'>
      {type === 'integer' ? 'number' : type}
    </Typography>
  );
};

export default OpenCloudTypeReference;
